module.exports = __webpack_public_path__ + "media/images/email_green_fill-bb68c274.svg";